<ng-container *ngIf="appearance === 'accordion'">
  <ng-container *ngIf="titleComponent === 'Faturamento dos Contratos'">
    <div class="accordion-field">
      <p class="ui-field-label">Status</p>
      <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
        <button type="button" class="combo-trigger" (click)="toggleDropdown('status')">
          <span>{{ statusTriggerLabel }}</span>
          <span class="combo-arrow"></span>
        </button>

        <div class="combo-dropdown" *ngIf="openDropdown === 'status'">
          <label
            class="combo-option"
            *ngFor="let control of statusInvoiceFormArray.controls">
            <input
              type="checkbox"
              [formControl]="getCheckedControl(control)" />
            <span>{{ control.get('label')?.value }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="accordion-field">
      <p class="ui-field-label">Banco</p>
      <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
        <button type="button" class="combo-trigger" (click)="toggleDropdown('bank')">
          <span>{{ bankTriggerLabel }}</span>
          <span class="combo-arrow"></span>
        </button>

        <div class="combo-dropdown" *ngIf="openDropdown === 'bank'">
          <label
            class="combo-option"
            *ngFor="let control of banksFormArray.controls">
            <input
              type="checkbox"
              [formControl]="getCheckedControl(control)" />
            <span>{{ control.get('label')?.value }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="accordion-field">
      <p class="ui-field-label">Tipo de Operação</p>
      <div class="combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()" (click)="$event.stopPropagation()">
        <button type="button" class="combo-trigger" (click)="toggleDropdown('operationType')">
          <span>{{ operationTypeTriggerLabel }}</span>
          <span class="combo-arrow"></span>
        </button>

        <div class="combo-dropdown" *ngIf="openDropdown === 'operationType'">
          <label
            class="combo-option"
            *ngFor="let control of operationTypesFormArray.controls">
            <input
              type="checkbox"
              [formControl]="getCheckedControl(control)" />
            <span>{{ control.get('label')?.value }}</span>
          </label>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<div class="filter" *ngIf="appearance === 'legacy'" [ngClass]="{ 'show-filter': showFilters }">
  <div class="filter-conteudo conteudo d-flex direction-column">
    <app-svg-icon src="/assets/icons/close-icon.svg"
      color="arrowGray"
      width="15px"
      height="15px"
      class="svgicon-close"
      (click)="filterOptions.toggleFilter()">
    </app-svg-icon>

    <div class="filter-titulo">
      {{ titulo }}
    </div>

    <div class="divider"></div>

    <form class="conteudo-form form d-flex direction-column justify-space-between"
      [formGroup]="filterForm">
      <ng-container *ngIf="titleComponent === 'Esteira de Apuração'">
        <div class="form-titulo">Fases:</div>

        <div class="form-lista d-flex direction-column">
          <div *ngFor="let control of stagesFormArray.controls; let i = index"
            formArrayName="stages">
            <ng-container [formGroupName]="i">
              <app-c-checkbox class="form-lista-linhas"
                [label]="control.get('label')?.value?.toLowerCase() === 'a estornar'
                                ? 'Pendente Estorno' 
                                : control.get('label')?.value"
                [control]="getCheckedControl(control)"
                [id]="'stage-' + i"></app-c-checkbox>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="divider"></div>
      <ng-container *ngIf="
          titleComponent === 'Esteira de Apuração' ||
          titleComponent === 'Faturamento dos Contratos'
        ">
        <div class="form-titulo direction-column">Status</div>

        <div class="form-lista d-flex direction-column">
          <ng-container formArrayName="statusInvoice">
            <div *ngFor="
                let control of statusInvoiceFormArray.controls;
                let j = index
              ">
              <ng-container [formGroupName]="j">
                <app-c-checkbox class="form-lista-linhas"
                  [label]="control.get('label')?.value"
                  [control]="getCheckedControl(control)"
                  [id]="'status-' + j"></app-c-checkbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="titleComponent === 'Repasse de Comissão'">
        <div class="form-titulo direction-column">Status do Lote</div>

        <div class="form-lista d-flex direction-column">
          <ng-container formArrayName="statusTransfer">
            <div *ngFor="
                let control of statusTransferFormArray?.controls;
                let b = index
              ">
              <ng-container [formGroupName]="b">
                <app-c-checkbox class="form-lista-linhas"
                  [label]="control.get('label')?.value"
                  [control]="getCheckedControl(control)"
                  [id]="'transfer-' + b"></app-c-checkbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div class="divider"></div>
        <div class="form-titulo direction-column">Status do OMIE</div>

        <div class="form-lista d-flex direction-column">
          <ng-container formGroupName="statusOrder">
            <div *ngFor="
                let control of statusOrderFormArray?.controls;
                let p = index
              ">
              <ng-container [formGroupName]="p">
                <app-c-checkbox class="form-lista-linhas"
                  [label]="control.get('label')?.value"
                  [control]="getCheckedControl(control)"
                  [id]="'order-' + p"></app-c-checkbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="titleComponent === 'Comissao Faturamento'">
        <div class="form-titulo direction-column">Banco</div>

        <div class="form-lista d-flex direction-column">
          <ng-container formArrayName="statusBank">
            <div *ngFor="
                let control of statusBankFormArray?.controls;
                let b = index
              ">
              <ng-container [formGroupName]="b">
                <app-c-checkbox class="form-lista-linhas"
                  [label]="control.get('label')?.value"
                  [control]="getCheckedControl(control)"
                  [id]="'bank-' + b"></app-c-checkbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div class="divider"></div>
        <div class="form-titulo direction-column">Período</div>

        <div class="form-lista d-flex direction-column" style="max-height: 300px;overflow: auto;">
          <ng-container formGroupName="statusPeriod">
            <div *ngFor="
                let control of statusPeriodsFormArray?.controls;
                let p = index
              ">
              <ng-container [formGroupName]="p">
                <app-c-checkbox class="form-lista-linhas"
                  [label]="control.get('label')?.value"
                  [control]="getCheckedControl(control)"
                  [id]="'period-' + p"></app-c-checkbox>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-container>



      <!-- filtro do legado -->
      <ng-container *ngIf="titleComponent === 'Faturamento dos Contratos' || titleComponent === 'Repasse de Comissão'">
        <div class="form-titulo direction-column">Outros</div>

        <div class="form-lista d-flex direction-column">
          <ng-container>

            <ng-container>
              <app-c-checkbox class="form-lista-linhas"
                [label]="'Legado'"
                [control]="isLegacy"
                (change)="checkCheckBoxvalue($event)"
                [id]="'isLegacy'"></app-c-checkbox>
            </ng-container>


          </ng-container>
        </div>
      </ng-container>
      
      <ng-container *ngIf="titleComponent === 'Esteira de Apuração' || titleComponent === 'Faturamento dos Contratos'">
        <div class="form-titulo direction-column">Alíquotas</div>
        <div class="form-lista d-flex direction-column">
          <ng-container>
            <div>
              <app-c-checkbox class="form-lista-linhas"
                [label]="'Zeradas'"
                [control]="isZeroRate"
                (change)="checkCheckBoxvalueZeroRate($event)"
                [id]="'isZeroRate'"></app-c-checkbox>
            </div>
          </ng-container>
        </div>
      </ng-container>

<ng-container *ngIf="titleComponent === 'Esteira de Apuração'">
        <div class="form-titulo direction-column">Contratos</div>
        <div class="form-lista d-flex direction-column">
          <ng-container>
            <div>
              <app-c-checkbox class="form-lista-linhas"
                [label]="'Sem Lotes'"
                [control]="withoutBatch"
                (change)="checkCheckBoxvalueWithouBatch($event)"
                [id]="'withoutBatch'"></app-c-checkbox>
            </div>
          </ng-container>
        </div>
      </ng-container>      


      <div class="divider"></div>
      <div class="form-botoes botoes d-flex justify-space-between">
        <button class="botoes-btn" (click)="clearFilter()">
          {{ buttonLabels.clearFilter }}
        </button>
        <button class="botoes-btn" (click)="applyFilters()">
          {{ buttonLabels.searchingFilter }}
        </button>
      </div>
    </form>
  </div>
</div>